import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useBanks = () => useQuery({ queryKey: [`banks`], queryFn: async () => {
    const callback = await API.get(`/banks`)
    return callback?.data
}, staleTime: 60000, gcTime: 1000 * 60 * 30 })

export default useBanks